type BadgePanels = {
  getPanel(id: string): { set(key: "content", value: string): unknown } | null;
  addPanel(panel: { id: string; content: string }): unknown;
};

const ENTITIES: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

const escapeHTML = (text: string) => text.replace(/[&<>"']/g, (c) => ENTITIES[c]);

export function identityBadgeHTML(label: string, name: string): string {
  return `<span class="badge bg-info badge-lg rounded-pill">${label} | ${escapeHTML(name)}
        <button class="btn btn-sm btn-link text-white p-0 ms-2" id="edit-template-name">
          <i class="fa-sharp fa-light fa-pencil"></i>
        </button>
      </span>`;
}

/** The editor keeps one badge panel per session, so a rename has to replace its content. */
export function showIdentityBadge(panels: BadgePanels, content: string): void {
  const panel = panels.getPanel("identity");
  if (panel) panel.set("content", content);
  else panels.addPanel({ id: "identity", content });
}
